import CategoryView from '../category/CategoryView';
import { usePageMeta } from '@/hooks/usePageMeta';

export default function Romance() {
  usePageMeta({
    title: '韩漫网恋爱漫画分类直达 - 韩漫漫画网',
    description: '韩漫网恋爱漫画分类：心动信号、双向暗恋、甜甜日常一站直达。韩漫漫画网聚合恋爱题材热门作品，分类清晰，点开即看。',
    keywords: '韩漫漫画网,韩漫网恋爱漫画,恋爱韩漫,甜宠韩漫,韩漫题材分类',
    canonical: 'https://lovecomix.github.io/romance',
  });
  return <CategoryView type="romance" />;
}